import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getProductionSites({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_PRODUCTION_SITES_REQUEST')

        return axios
            .get(`/production-sites/production-sites${paginate}${query}`)
            .then(response => {
                commit('GET_PRODUCTION_SITES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PRODUCTION_SITES_FAILURE')
                handleApiError(error, 'Pobranie stanowisk raportowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionSitesBase({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_PRODUCTION_SITES_BASE_REQUEST')

        return axios
            .get(`/production-sites/production-sites-base${paginate}${query}`)
            .then(response => {
                commit('GET_PRODUCTION_SITES_BASE_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PRODUCTION_SITES_BASE_FAILURE')
                handleApiError(error, 'Pobranie stanowisk raportowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionSite(context, id) {
        return axios
            .get(`/production-sites/production-sites/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o stanowisku raportowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createProductionSite({ commit }, payload) {
        return axios
            .post('/production-sites/production-sites', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Stanowisko raportowania zostało dodane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie stanowiska raportowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateProductionSite({ commit }, payload) {
        return axios
            .put(`/production-sites/production-sites/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Stanowisko raportowania zostało zaktualizowane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja stanowiska raportowania nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteProductionSite({ commit }, payload) {
        return axios
            .delete(`/production-sites/production-sites/${payload}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Stanowisko raportowania zostało usunięte.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie stanowiska raportowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPrinters() {
        return axios
            .get('/print-manager/dicts/printers')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie drukarek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionSitesTypes() {
        return axios
            .get('/production-sites/production-site-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów stanowisk nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionSitesGroups({ commit }, {
        query = ''
    } = {}) {

        return axios
            .get(`/production-sites/production-site-groups${query}`)
            .then(response => {
                commit('GET_PRODUCTION_SITE_GROUPS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie grup stanowisk nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAllowedReportItemTypes() {
        return axios
            .get('/reports/reports/dicts/report-item-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów obiektów jakie można raportować na wybranym stanowisku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setProductionSitesFilters({ commit }, filters) {
        commit('SET_FILTERS', filters)
    },
    clearProductionSitesFilters({ commit }) {
        commit('CLEAR_FILTERS')
    },
    clearProductionSites({ commit }) {
        commit('CLEAR_PRODUCTION_SITES')
    }
}